import React from 'react';
import IconInvite from '../../../assets/dealroom-icons/invite.svg';

const PreviewAgreementText = () => {
  return (
    <div>
      <h3 className="text-center">Preview your Agreement</h3>
      <p className="text-gray preview-description">
        Full names, addresses, signatures, and things that are pending (in red)
        will only appear in the agreement once everyone has agreed and signed
        it.&nbsp; If you want to have an attorney review/edit your agreement,
        click on&nbsp;&nbsp;
        <img src={IconInvite} alt="Insert invite attorney" />
        &nbsp;&nbsp;from the toolbar above.&nbsp; Edits will not become part of
        the final agreement unless they are accepted by all collaborators and
        attorneys.
      </p>
    </div>
  );
};

export default PreviewAgreementText;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/PreviewAgreementText.js